(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});

  DNB.Production = {
    init: function () {
      var root = document.querySelector("[data-production]");
      if (!root || root.getAttribute("data-production-init") === "1") return;
      root.setAttribute("data-production-init", "1");

      var nav = root.querySelector(".production__nav");
      var items = root.querySelectorAll("[data-prod-item]");
      //var images = root.querySelectorAll("[data-prod-image]");
      var images = root.querySelectorAll("[data-prod-image]:not(:first-child)");
      var highlight = root.querySelector("[data-prod-highlight]");
      var active = -1;

      function moveHighlight(item) {
        if (!highlight || !item) return;
        highlight.style.width = item.offsetWidth + "px";
        highlight.style.transform = "translateX(" + (item.offsetLeft - 4) + "px)";
      }

      function activate(index) {
        active = index;
        items.forEach(function (it, i) { it.classList.toggle("is-active", i === index); });
        images.forEach(function (im, i) { im.classList.toggle("is-visible", i === index); });
        if (highlight) highlight.style.opacity = "1";
        moveHighlight(items[index]);
      }

      // Default: hiçbir item aktif değil, highlight gizli, production__video görünür
      function reset() {
        active = -1;
        items.forEach(function (it) { it.classList.remove("is-active"); });
        images.forEach(function (im) { im.classList.remove("is-visible"); });
        if (highlight) highlight.style.opacity = "0";
      }

      items.forEach(function (item, index) {
        item.addEventListener("mouseenter", function () { activate(index); });
        item.addEventListener("click", function () { activate(index); });
      });

      // Nav alanından çıkınca tümü pasif + görsel gizlenir
      if (nav) nav.addEventListener("mouseleave", reset);

      reset();
      window.addEventListener("resize", function () {
        if (active >= 0) moveHighlight(items[active]);
      });
    }
  };
})(window, document);
